export function useContentPreview() {
  const route = useRoute();

  return computed(() => route.query.draft === 'true');
}
